"use client";

import * as React from "react";
import { ShieldCheck, Clock, RefreshCw, ArrowRight } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
const accordionData = [{
  id: "item-1",
  title: "Step 1: Call Olivia",
  content: "Connect with our AI voice agent for a 15-20 minute discovery session. Olivia identifies your operational bottlenecks in real-time, pinpointing exactly where your team is losing valuable hours every week.",
  icon: "shield"
}, {
  id: "item-2",
  title: "Step 2: Data Synthesis",
  content: "Our proprietary AI engine processes your conversation data against thousands of automation use cases, in addition to utilization of our teams real world experience. We map your specific workflows to high-impact AI solutions that deliver immediate ROI.",
  icon: "clock"
}, {
  id: "item-3",
  title: "Step 3: The AI Assessment",
  content: "Within 48 hours, receive your personalized report. A comprehensive roadmap identifying hidden hours and a step-by-step implementation guide to reclaim your time and scale your business.",
  icon: "refresh"
}];
export default function TheOliviaExperience() {
  const renderIcon = (iconName: string) => {
    switch (iconName) {
      case "shield":
        return <ShieldCheck className="size-5 text-primary" />;
      case "clock":
        return <Clock className="size-5 text-primary" />;
      case "refresh":
        return <RefreshCw className="size-5 text-primary" />;
      default:
        return null;
    }
  };
  return <section data-section-id="236082" id="the-olivia-experience" className="bg-background text-foreground relative overflow-hidden py-16 md:py-24 lg:py-32">
      {}

      <div className="container relative z-10 mx-auto px-4 md:px-6 max-w-7xl">
        <div className="mb-12 text-center md:mb-16">
          <h2 className="font-default text-3xl font-bold tracking-tight sm:text-4xl md:text-5xl text-foreground">
            The <span className="text-primary">Olivia</span> Experience
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-muted-foreground md:text-lg font-default">
            A streamlined three-step process to uncover the hidden hours in your business operations.
          </p>
        </div>

        <div className="grid gap-12 lg:grid-cols-2 lg:gap-16 items-center">
          {}
          <div className="relative order-2 lg:order-1 group">
            <div className="absolute -inset-1 rounded-2xl bg-gradient-to-tr from-primary/10 to-primary/5 opacity-50 blur-xl transition-opacity duration-500 group-hover:opacity-70" />
            <div className="relative rounded-2xl border border-border bg-card/30 p-2 backdrop-blur-sm shadow-2xl">
              <div className="relative overflow-hidden rounded-xl bg-muted/20 aspect-square md:aspect-[4/3] lg:aspect-square flex items-center justify-center">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681550/img/pexels-cmrcn-36668710.jpg" alt="RecoupTime AI Assessment Report" className="object-cover w-full h-full transition-transform duration-700 group-hover:scale-105 !text-[rgba(255,255,255,1)]" loading="lazy" src="https://electric-eft.10web.cloud/wp-content/uploads/2026/05/pexels-matreding-11692910-scaled.jpg" />
                {}
                <div className="absolute bottom-6 right-6 flex items-center gap-2 rounded-lg border border-primary/30 bg-background/90 px-4 py-2 backdrop-blur-md shadow-lg">
                  <div className="size-2 rounded-lg bg-primary animate-pulse" />
                  <span className="font-default text-xs font-bold tracking-widest text-foreground uppercase">
                    Live Analysis
                  </span>
                </div>
              </div>
            </div>
          </div>

          {}
          <div className="order-1 lg:order-2 flex flex-col justify-center">
            <div className="rounded-2xl border border-border bg-card/40 p-6 backdrop-blur-md shadow-xl md:p-8">
              <Accordion type="multiple" className="w-full">
                {accordionData.map((item, i) => <AccordionItem key={item.id} value={item.id} data-index={i} className="border-border/50 py-2">
                    <AccordionTrigger className="hover:no-underline group">
                      <div className="flex items-center gap-4 text-left">
                        <div className="flex size-10 shrink-0 items-center justify-center rounded-lg bg-muted/30 border border-border transition-colors group-hover:bg-primary/10 group-hover:border-primary/40">
                          {renderIcon(item.icon)}
                        </div>
                        <span className="font-default text-lg font-semibold text-foreground">
                          {item.title}
                        </span>
                      </div>
                    </AccordionTrigger>
                    <AccordionContent className="text-muted-foreground font-default leading-relaxed pt-2 pb-6 pl-14">
                      {item.content}
                    </AccordionContent>
                  </AccordionItem>)}
              </Accordion>

              <div className="mt-8 pt-6 border-t border-border">
                <Button asChild size="lg" className="w-full sm:w-auto group bg-primary hover:bg-primary/90 text-primary-foreground rounded-md shadow-md">
                  <Link to="/ContactPage">
                    Start Your Assessment
                    <ArrowRight className="ml-2 size-4 transition-transform group-hover:translate-x-1" />
                  </Link>
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}